export default __webpack_public_path__ + "static/media/s18m02_c.ab6750b0.png";